import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../../core/modules/shared.module';
import { ExportUsersDialogComponent } from './export.users.dialog.component';


const routes =
  [{ path: 'exportusersdialog', component: ExportUsersDialogComponent }];

@NgModule({
  declarations: [ExportUsersDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [ExportUsersDialogComponent]
})

export class ExportUsersModule { }


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/export/export.users.dialog.module.ts